import React from "react";
import "../styles/hamburger.scss";
import { useSpring, animated } from "react-spring";
import ScrollIntoView from "react-scroll-into-view";

export default function Hamburger(props) {
  const hamburgerAnimation = useSpring({
    from: { opacity: 0, transform: "translatey(-4em)" },
    to: {
      opacity: props.toggle ? 1 : 0,
      transform: props.toggle ? "translatey(0)" : "translatey(-4em)",
      pointerEvents: props.toggle ? "auto" : "none",
    },
  });
  return (
    <animated.div style={hamburgerAnimation} className="hamburgerContainer">
      <ScrollIntoView
        onClick={() => {
          props.handleToggle();
        }}
        selector="#mission"
      >
        <li>mission</li>
      </ScrollIntoView>
      <ScrollIntoView
        onClick={() => {
          props.handleToggle();
        }}
        selector="#products"
      >
        <li>prodotti</li>
      </ScrollIntoView>
      <ScrollIntoView
        onClick={() => {
          props.handleToggle();
        }}
        selector="#contact"
      >
        <li>contatto</li>
      </ScrollIntoView>
    </animated.div>
  );
}
